import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
	Typography,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	Divider
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { formatString } from '../../../utils/numbers';
import { RxShare2 } from 'react-icons/rx';
import { RiInstallLine } from 'react-icons/ri';

const PREFIX = 'PWADialog';

const classes = {
	title: `${PREFIX}-alert-dialog-title`
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
	'.MuiPaper-root': {
		position: 'absolute',
		bottom: 0,
		width: '93%'
	},

	[`& .${classes.title}`]: {
		padding: '20px 24px'
	}
}));

export default function InstallPWADialog(props) {
	const handleClose = () => {
		localStorage.setItem('ignoreInstallPWA', 'true');
		props.setOpen(false);
	};

	return (
		<StyledDialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<Typography variant="h6" className={classes.title}>
				<RiInstallLine></RiInstallLine>
				{props.title}
			</Typography>
			<Divider></Divider>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{formatString(props.description)}
				</DialogContentText>
				{props.displaySteps ? (
					<>
						<Typography>{props.firstStep}</Typography>
						<Typography>
							{props.secondStep}{' '}
							<span style={{ backgroundColor: grey[200], fontSize: '18px' }}>
								<RxShare2 />
							</span>
						</Typography>
						<Typography>
							{props.thirdStep}{' '}
							<span style={{ backgroundColor: grey[200], fontSize: '18px' }}>
								Add to homescreen
							</span>
						</Typography>
					</>
				) : null}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="outlined" color="primary">
					Inchide
				</Button>
				{props.displayInstallPWA ? (
					<Button onClick={props.installPWA} variant="contained" color="primary">
						Adaugă
					</Button>
				) : null}
			</DialogActions>
		</StyledDialog>
	);
}
